import { createAction, props } from '@ngrx/store';
import { IGeneralSettingsState } from './general-settings.state';

export const setGeneralSettingsData = createAction(
  '[General Settings] Set General Settings Data',
  props<{ data: IGeneralSettingsState }>()
);

export const clearGeneralSettingsData = createAction(
  '[General Settings] Clear General Settings Data'
);
